import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import UserForm, { UserFormFields } from '../../components/User/UserForm';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import UserFinancial from '../../components/User/UserFinancial';

export default function UsersEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [formFields, setFormFields] = useState<UserFormFields>(
    null as unknown as UserFormFields
  );
  const [formErrors, setFormErrors] = useState({});

  const getUser = async () => {
    if (organization && id) {
      const { data } = await api.get(
        `admin/organizations/${organization.id}/users/${id}`
      );

      setFormFields({
        name: data.name,
        role: data.role,
        email: data.email,
        paymentValue: data.paymentValue,
      });
      setIsLoading(false);
    }
  };

  const onSubmit = async (data: UserFormFields) => {
    try {
      const { paymentValue, ...rest } = data;
      await api.put(`admin/organizations/${organization.id}/users/${id}`, rest);

      navigate('/admin/users');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  useEffect(() => {
    getUser();
  }, [organization, id]);

  return (
    <>
      <ul className='nav nav-tabs mb-3'>
        <li className='nav-item'>
          <button
            type='button'
            className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
            aria-current='page'
            onClick={() => setActiveTab(0)}
          >
            Dados
          </button>
        </li>
        <li className='nav-item '>
          <button
            type='button'
            className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
            onClick={() => setActiveTab(1)}
          >
            Financeiro
          </button>
        </li>
      </ul>
      {activeTab === 0 && (
        <UserForm
          isUpdate
          isLoading={isLoading}
          title={`Editar Colaborador ${id}`}
          formFields={formFields}
          formErrors={formErrors}
          onSubmit={onSubmit}
        />
      )}
      {activeTab === 1 && (
        <UserFinancial
          id={Number(id)}
          formFields={formFields}
          refreshUser={getUser}
        />
      )}
    </>
  );
}
